import { formatInternational } from 'lib-shared-phone-numbers';
/** Converts a phone number to a phone number select item. */
export const searchUserToPhoneNumberSelectItem = (user) => {
    var _a, _b, _c;
    const number = (_a = user.phone_number) !== null && _a !== void 0 ? _a : '';
    return {
        id: number,
        name: (_b = formatInternational(number)) !== null && _b !== void 0 ? _b : '',
        description: (_c = user.display_name) !== null && _c !== void 0 ? _c : '',
    };
};
